import React, { useEffect, useState } from "react";
import { Row, Col, Button, Grid, Drawer } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import TicketList from "./TicketList";
import TicketDetails from "./TicketDetails";
import UserInfoPanel from "./UserInfoPanel";
import useHelpRequests from "hooks/help&support/useHelpRequest";
import { useAppContext } from "providers/AppProvider";

const { useBreakpoint } = Grid;

export default function HelpdeskPage() {
  const { helpRequests, loading, fetchAll, updateStatus, searchHelpRequests } =
    useHelpRequests();
  const [selected, setSelected] = useState(null);
  const [showUserDrawer, setShowUserDrawer] = useState(false);
  const [showDetails, setShowDetails] = useState(false); // for mobile view
  const [showUserInfo, setShowUserInfo] = useState(false); // toggle user info

  const { config } = useAppContext();
  const isCollapsed = config.isNavbarVerticalCollapsed;

  const screens = useBreakpoint(); // detects screen sizes

  const isMobile = !screens.lg; // < 992px
  const isTabletOrDesktop = screens.lg; // >= 992px

  useEffect(() => {
    fetchAll();
  }, []);

  useEffect(() => {
    if (helpRequests.length && !selected) {
      setSelected(helpRequests[0]);
    }
  }, [helpRequests]);

  const handleSelectTicket = (ticket) => {
    setSelected(ticket);
    if (isMobile) setShowDetails(true);
  };

  return (
    <>
      {isMobile && showDetails && (
        <div className="mobile-back-btn" style={{ padding: 10 }}>
          <Button icon={<LeftOutlined />} onClick={() => setShowDetails(false)}>
            Back to List
          </Button>
          <Button
            style={{ marginLeft: 10 }}
            onClick={() => setShowUserInfo((prev) => !prev)}
          >
            {showUserInfo ? "Hide User Info" : "Show User Info"}
          </Button>
        </div>
      )}

      <Row gutter={16} style={{ paddingTop: 16 }}>
        {(isTabletOrDesktop || !showDetails) && (
          <Col lg={isCollapsed ? 8 : 10} xs={24}>
            <TicketList
              tickets={helpRequests}
              loading={loading}
              selected={selected}
              onSelect={handleSelectTicket}
              onSearch={searchHelpRequests}
            />
          </Col>
        )}

        {(isTabletOrDesktop || (showDetails && !showUserInfo)) && selected && (
          <Col lg={isCollapsed ? 10 : 14} xs={24}>
            <TicketDetails
              ticket={selected}
              onShowUserInfo={() => setShowUserDrawer(true)}
              isCollapsed={isCollapsed}
            />
          </Col>
        )}

        {selected && (
          <Col
            lg={isCollapsed ? 6 : 0}
            xs={isMobile ? 24 : 0}
            style={{
              display:
                (isTabletOrDesktop && isCollapsed) || (isMobile && showUserInfo)
                  ? "block"
                  : "none",
            }}
          >
            <UserInfoPanel ticket={selected} onStatusChange={updateStatus} />
          </Col>
        )}
      </Row>

      <Drawer
        title={<span style={{ fontFamily: "Inter" }}>User Information</span>}
        placement="right"
        size={400}
        zIndex={99999}
        onClose={() => setShowUserDrawer(false)}
        open={showUserDrawer}
      >
        {selected && (
          <UserInfoPanel ticket={selected} onStatusChange={updateStatus} />
        )}
      </Drawer>
    </>
  );
}
